module.exports = __webpack_public_path__ + "media/img/pages/career-starter/collection/2026_en-16a73ab4839d79a260a7648a2b8aeaaf.jpg";